import React, { createContext } from "react";
import { type PillarModalControl } from "shared/components/pillar-modal/usePillarModalControl";
import { type FormView } from "shared/mappers/database/form/form";
import { type ReviewInstanceAssignmentView } from "shared/mappers/database/review/reviewInstanceAssignment";
import { type ReviewSessionView } from "shared/mappers/database/review/reviewSession";
import { type HubReviewsVotingTab } from "hub/src/components/reviews/useHubReviewsVotingTabsArray";

type HubReviewsVotingPageContextType = {
  reviewSession: ReviewSessionView;
  reviewInstanceAssignment: ReviewInstanceAssignmentView;
  reviewInstanceAssignmentIsFetching: boolean;
  nextInstanceId: number | undefined;
  formDesign: FormView;
  formDesignIsLoading: boolean;
  previousInstanceId: number | undefined;
  recusalModalControl: PillarModalControl;
  tabs: HubReviewsVotingTab[];
  selectedTab: string;
  setSelectedTab: (tab: string) => void;
};
export const HubReviewsVotingPageContext = createContext<
  HubReviewsVotingPageContextType | undefined
>(undefined);

export const useHubReviewsVotingPageContext = () => {
  const context = React.useContext(HubReviewsVotingPageContext);
  if (!context) {
    throw new Error(
      "useHubReviewsVotingPageContext must be used within a HubReviewsVotingPageContextProvider",
    );
  }
  return context;
};
